import { checkAuth } from "../auth/AuthContext";
import { parsePayload, throwCommError, OperationError } from "../DAO";
import { UsageReport } from "./UsageReport";
import { BillingReport } from "./BillingReport";

export async function fetchUsage(): Promise<UsageReport[]> {
   const payload = await fetch("../admin/report/usage", {
      method: "POST",
      headers: {
         Accept: "application/json",
      },
   })
      .catch(throwCommError)
      .then(parsePayload)
      .then(checkAuth);
   if (payload.success) {
      let value: any[];
      if (Array.isArray(payload.value)) {
         value = payload.value;
      } else {
         value = [];
      }
      return value.map(UsageReport.parse);
   }
   throw OperationError.from(payload);
}

export async function fetchBilling(): Promise<BillingReport[]> {
   const payload = await fetch("../admin/report/billing", {
      method: "POST",
      headers: {
         Accept: "application/json",
      },
   })
      .catch(throwCommError)
      .then(parsePayload)
      .then(checkAuth);
   if (payload.success) {
      let value: any[];
      if (Array.isArray(payload.value)) {
         value = payload.value;
      } else {
         value = [];
      }
      return value.map(BillingReport.parse);
   }
   throw OperationError.from(payload);
}
